<template>
  <section>
    <div class="tip" style="margin:0 0 0 20px">* 项目基本资料</div>
    <el-form-item label="调动人员" style="overflow:inherit;">
      <el-col :span="12">
        <div class="transfer-user">
          <el-input size="small" placeholder="请输入调动人员姓名 (模糊搜索)" v-model="filterName"></el-input>
          <div class="transfer-filter-list" v-if="filterListStatus">
            <div @click="checkedUser(item)" class="tfl-item" v-for="item,i in filterList">
              {{item.name}} - {{ item.company+"/"+item.department+"/"+item.zw }}
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="12">

        <!-- <user-info style="display:inline-block;width:auto;margin-left:10px;" :userData='transferUser'></user-info> -->
      </el-col>
    </el-form-item>
    <el-form-item label="调动时间">
      <el-date-picker v-model="form.transferTime" value-format="yyyy-MM-dd" size="small" type="date" placeholder="选择日期">
      </el-date-picker>
    </el-form-item>
    <div class="clear">
      <el-col :span="8">
        <el-form-item label="调出公司">
          <el-input size="small" disabled v-model="form.outCompany"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="调出部门">
          <el-input size="small" disabled v-model="form.outDep"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="调出岗位">
          <el-input size="small" disabled v-model="form.outPosition"></el-input>
        </el-form-item>
      </el-col>
    </div>
    <div class="clear">
      <el-col :span="8">
        <el-form-item label="调入公司">
          <el-select size="small" style="width:100%;" v-model="form.inCompany">
            <el-option v-for="depName,i in depNames" :key="i" :label="depName" :value="depName"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="调入部门">
          <!-- <el-input size="small" v-model="form."></el-input> -->
          <el-select size="small" style="width:100%;" @change="forceUpdate" v-model="form.inDep">
            <el-option v-for="inDepName,j in depInDeps" v-if="inDepName.data" :key="j" :label="inDepName.data"
              :value="inDepName.data"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="调入岗位">
          <el-input size="small" v-model="form.inPosition"></el-input>
        </el-form-item>
      </el-col>
    </div>

    <el-form-item label="本人意见">
      <el-input type="textarea" placeholder="调动本人意见" :autosize="{ minRows: 5, maxRows: 8}" size="small"
        v-model="form.reason"></el-input>
    </el-form-item>


    <!-- 选择公司/部门 -->
    <!-- <div class="pop-room asset-type-pop" v-if="organizationListStatus">
      <a href="javascript:;" @click="organizationListStatus=false" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-col :span="22">
          <el-tree style="max-height:400px;overflow-y:auto;" :data="organizationList" show-checkbox
            :props="organizationProps" @check="organizationSelectSuccess" node-key="id" ref="organizationTree">
          </el-tree>
        </el-col>
      </div>
    </div> -->

  </section>
</template>

<style lang="scss" scoped>
  .transfer-user {
    position: relative;
    z-index: 9999;

    .transfer-filter-list {
      position: absolute;
      border: 1px #ccc solid;
      background: #fff;
      // top: 40px;
      left: 0;
      min-width: 500px;
      height: 500px;
      overflow-y: auto;
      z-index: 9999;

      .tfl-item {
        border-bottom: 1px #ccc solid;
        padding: 0 10px;
      }
    }
  }
</style>
<script>
  import {
    mapState
  } from "vuex";

  import UserInfo from '@/components/UserInfo'
  export default {
    props: ['formByFather', 'userData', ],
    computed: {
      ...mapState({
        contactSelectArr: state => state.main.contactSelectArr,
        organization: state => state.main.organization,
      }),
    },
    components: {
      UserInfo,
    },
    data() {
      return {
        form: {},
        transferUser: "",
        filterListStatus: false,
        filterNameSearch: true,

        // 所有公司
        depNames: ['象山县水务集团有限公司', '象山县第一自来水有限公司', '象山县第二自来水有限公司', '象山县第三自来水有限公司', '象山县污水处理有限公司', '象山县原水有限公司',
          '象山县水务建设投资有限公司'
        ],
        depInDeps: [],
        filterName: '',
        filterList: [],

        // 设置部门
        // depArrIndex: "",
        // dep: "",
        // depF: "",
        // organizationListStatus: false,
        // organizationList: [],
        // organizationProps: {
        //   children: 'childDepts',
        //   label: 'name'
        // },
        // organizationCheck: {},
      }
    },
    mounted() {
      this.form = this.formByFather
      this.getSelectLeader()
      // this.organizationList = this.organization[0].childDepts
      // for (let i = 0; i < this.organizationList.length; i++) {
      //   let _item = this.organizationList[i]
      //   if (_item.childDepts.length > 0) {
      //     _item.disabled = true
      //   }
      // }
    },
    methods: {
      // select刷新view
      forceUpdate(item) {
        this.$forceUpdate()
      },
      // 通过userId获取调动人员信息
      getSelectLeader() {
        console.log(this.form.archivesId)
        if (this.form.archivesId) {
          console.log(this.form.archivesId)
          ajax.get('/human/archives/detail/' + this.form.archivesId, "", (res) => {
            this.transferUser = res.vo
            this.filterNameSearch = false
            
            this.filterName = this.transferUser.name + " - " + this.transferUser.company + "/" + this.transferUser
              .department + "/" + this.transferUser.zw

          })
        }
      },
      // 选中checkedUser
      checkedUser(item) {
        this.transferUser = item
        this.form.archivesId = item.archivesId
        this.form.outCompany = item.company
        this.form.outDep = item.department
        this.form.outPosition = item.zw

        this.filterNameSearch = false
        this.filterName = item.name + " - " + item.company + "/" + item.department + "/" + item.zw
        this.filterList = []
        this.filterListStatus = false
      },
      // 添加调动人员
      // addUsers() {
      //   let _sr = this.selectLeader
      //   this.$store.commit('set_contactSelectArr', _sr)
      //   this.$store.commit('set_contactApprovalItem', false)

      //   this.$store.commit('set_contactShow', true)
      //   this.$store.commit('set_contactSingleSelect', true)

      //   setTimeout(() => {
      //     this.selectType = 3
      //   }, 500)
      // },
      getFromData() {
        return this.form
      },

      // 设置部门
      // addDeps(index) {
      //   this.organizationListStatus = true
      //   // this.depArrIndex = index
      //   setTimeout(() => {
      //     this.$refs.organizationTree.setCheckedNodes([this.dep])
      //   }, 100)
      // },
      // 确认选择公司/部门
      // organizationSelectSuccess(node, current) {
      //   console.log(node)

      //   let _nodes = this.$refs.organizationTree.getCheckedNodes()
      //   if (_nodes.length > 0) {
      //     this.organizationListStatus = false
      //     this.dep = node
      //     this.$refs.organizationTree.setCurrentNode([this.dep])
      //   }
      // },
      // deleteDeps(arrIndex, index) {
      //   // this.depArr[arrIndex].splice(index, 1)
      // },
    },
    watch: {
      formByFather() {
        this.form = this.formByFather
        this.getSelectLeader()
        // this.selectLeader = [this.form.userArchives.userVO]
        // this.dep = this.form.inDep
      },
      // 调入公司
      'form.inCompany'() {
        // this.form.inDep = ''
        ajax.post('/human/transfer/dept', {
          company: this.form.inCompany
        }, res => {
          this.depInDeps = res.vo.array
        })
      },
      // 从花名册模糊搜索调动人员
      filterName() {
        if (!this.filterNameSearch) {
          this.filterNameSearch = true
          return
        }
        ajax.post('/human/transfer/user', {
          name: this.filterName
        }, res => {
          this.filterList = res.vo.array
          this.filterListStatus = true
        })
      },
      // contactSelectArr() {
      //   if (this.selectType == 3) {
      //     this.selectLeader = this.contactSelectArr
      //     this.selectType = 0
      //   }
      // },
      // selectLeader() {
      //   console.log(this.selectLeader[0])
      //   this.form.userId = this.selectLeader[0] ? this.selectLeader[0].id : ''
      //   ajax.get('/human/archives/' + this.form.userId, "", (res) => {
      //     this.form.outCompany = res.vo.company
      //     this.form.outDep = res.vo.department
      //     this.form.outPosition = res.vo.zw
      //   })
      // },
      // dep() {
      //   if (!this.dep) {
      //     return
      //   }
      //   this.form.inDepId = this.dep.id
      //   for (let i = 0; i < this.organizationList.length; i++) {
      //     if (this.organizationList[i].depId == this.dep.parentId) {
      //       this.depF = this.organizationList[i]
      //     }
      //   }
      // },
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/personnel/createTransferApproval.vue